import { combineReducers } from 'redux';

import { reducer as httpRequestReducer } from '@travel/http-request';
import { reducer as i18nReducer } from '@travel/i18n';

import { authCodeReducer } from './authCode/slice';
import { commonErrorReducer } from './commonError/slice';
import { mediaGalleryReducer } from './mediaGallery/slice';
import { profileByIdReducer } from './profileById/slice';
import { providerFiltersReducer } from './providerFilters/slice';
import { providerSummaryReducer } from './providerSummary/slice';
import { updateAnonymityReducer } from './reviewAnonymity/slice';
import { reviewConfigReducer } from './reviewConfig/slice';
import { deleteReviewReducer } from './reviewDelete/slice';
import { reviewListReducer } from './reviewList/slice';
import { reportReviewReducer } from './reviewReport/slice';
import { userAgentReducer } from './userAgent/slice';
import { userProfileReducer } from './userProfile/slice';
import { snsDefaultValueReducer } from './snsDefaultList/slice';
import { routerReducer } from './__router/slice';
import { aiReducer } from './ai/slice';
import { seoReducer } from './seo/slice';
import { providerCommonHeaderReducer } from './providerCommonHeader/slice';
import { mediaReducer } from './media/slice';

export default combineReducers({
  _i18n: i18nReducer,
  _httpRequest: httpRequestReducer,
  authCode: authCodeReducer,
  commonError: commonErrorReducer,
  reviewList: reviewListReducer,
  seo: seoReducer,
  userAgent: userAgentReducer,
  router: routerReducer,
  userProfile: userProfileReducer,
  providerSummary: providerSummaryReducer,
  mediaGallery: mediaGalleryReducer,
  providerFilters: providerFiltersReducer,
  profileById: profileByIdReducer,
  reviewConfig: reviewConfigReducer,
  ai: aiReducer,
  deleteReview: deleteReviewReducer,
  reportReview: reportReviewReducer,
  updateAnonymity: updateAnonymityReducer,
  defaultSNSList: snsDefaultValueReducer,
  providerCommonHeader: providerCommonHeaderReducer,
  media: mediaReducer,
});
